<template>
  <div>
    <div class="title-order">
      <span class="content-order">
        <strong>{{ form.code }}</strong></span
      >
      <span style="margin: 0 8px; line-height: 16px">|</span>
      <span class="content-order">Ngày đặt hàng
        <strong
          >{{ moment(form.order_date).format("DD-MM-YYYY") }}
        </strong></span>
      <span style="margin: 0 8px; line-height: 16px">|</span>
      <span class="title-status">{{
        renderOrderCustomerStatus({ status: form.status })
      }}</span>
      <div
        v-if="
          form.status == orderCustomerStatusConstant.DANG_VAN_CHUYEN && transportations.length > 0
        "
      >
        <span style="margin: 0 8px; line-height: 16px">|</span>
        <span class="content-order">
          <a class="show-map" @click="showModal"
            >Xem lịch trình <EnvironmentOutlined
          /></a>
        </span>
      </div>
    </div>

    <a-row style="max-height: 70vh">
      <a-col span="12">
        <a-row>
          <a-col span="12">
            <div class="order-info">
              <div class="descriptions-title">Địa chỉ nhận hàng</div>
              <div class="descriptions-info">
                <div class="name-of-destination">
                  {{ form.name_of_destination }}
                </div>
                <div class="mobile-of-destination">
                  {{ form.mobile_no_of_destination }}
                </div>
                <div class="address">
                  {{ form.location_destination_detail }}
                </div>
                <div class="address">
                  {{ form.name_of_location_destination_id }}
                </div>
                <div class="time">
                  {{
                    form.ETD_date
                      ? moment(String(form.ETD_date)).format("DD-MM-YYYY")
                      : ""
                  }}
                  {{ form.ETD_time ? form.ETD_time : "" }}
                </div>
              </div>
            </div>
          </a-col>
          <a-col span="12">
            <div class="order-info" :style="{ padding: '16px 0px' }">
              <div class="descriptions-title">Địa chỉ trả hàng</div>
              <div class="descriptions-info">
                <div class="name-of-arrival">
                  {{ form.name_of_arrival }}
                </div>
                <div class="mobile-of-destination">
                  {{ form.mobile_no_of_arrival }}
                </div>
                <div class="address">
                  {{ form.location_arrival_detail }}
                </div>
                <div class="address">
                  {{ form.name_of_location_arrival_id }}
                </div>
                <div class="time">
                  {{
                    form.ETA_date
                      ? moment(String(form.ETA_date)).format("DD-MM-YYYY")
                      : ""
                  }}
                  {{ form.ETA_time ? form.ETA_time : "" }}
                </div>
              </div>
            </div>
          </a-col>
        </a-row>
        <div class="order-info">
          <a-row>
            <a-col span="12">
              <b>Số đơn hàng</b>
              <div>{{form.order_no}}</div>
            </a-col>
            <a-col span="12">
              <b>Số hóa đơn</b>
              <div>{{form.bill_nos}}</div>
            </a-col>
          </a-row>
        </div>
        <div class="order-info">
          <a-row>
            <a-col span="12">
              <b>Số khung</b>
              <div>{{form.vin_nos}}</div>
            </a-col>
            <a-col span="12">
              <b>Số model</b>
              <div>{{form.model_nos}}</div>
            </a-col>
          </a-row>
        </div>
        <div class="order-info">
          <a-row>
            <a-col span="12">
              <b>Mã hàng hóa</b>
              <div>{{form.goods_code}}</div>
            </a-col>
            <a-col span="12">
              <b>Tên hàng hóa</b>
              <div>{{form.goods_name}}</div>
            </a-col>
          </a-row>
        </div>
        <div class="order-info">
          <a-row>
            <a-col span="12">
              <b>Người liên hệ nhận hàng</b>
              <div>{{form.user_destination}}</div>
            </a-col>
            <a-col span="12">
              <b>Người liên hệ trả hàng</b>
              <div>{{form.user_arrival}}</div>
            </a-col>
          </a-row>
        </div>
        <div class="order-info">
          <a-row>
            <a-col span="12">
              <b>SĐT liên hệ nhận hàng</b>
              <div>{{form.number_phone_destination}}</div>
            </a-col>
            <a-col span="12">
              <b>SĐT liên hệ trả hàng</b>
              <div>{{form.number_phone_arrival}}</div>
            </a-col>
          </a-row>
        </div>
        <a-divider type="horizontal" />
        <div class="vehicle-info">
          <div class="ant-descriptions-title">Thông tin hàng hóa</div>
          <a-descriptions class="pdt-12" layout="horizontal" :column="3">
            <a-descriptions-item label="Tổng khối lượng (kg)">
              {{ form.weight ? formatNumber(form.weight) : 0 }}
            </a-descriptions-item>
            <a-descriptions-item label="Tổng dung tích (m3)">
              {{ form.volume ? formatNumber(form.volume) : 0 }}
            </a-descriptions-item>
            <a-descriptions-item label="Tổng quãng đường">
              {{ form.distance ? formatNumber(form.distance) : 0 }}
            </a-descriptions-item>
          </a-descriptions>
        </div>
        <div class="vehicle-info">
          <div class="ant-descriptions-title">Thông tin xe</div>
          <div class="infinite-container">
            <div class="ant-list ant-list-split ant-list-bordered">
              <div class="ant-list-header ant-list-header-sticky">
                <a-row>
                  <a-col class="textLeft" :span="12">
                    <p class="header-list">Chủng loại xe</p>
                  </a-col>
                  <a-col class="textRight" :span="10"
                    ><p class="header-list">Số lượng</p></a-col
                  >
                </a-row>
              </div>
              <ul
                class="ant-list-items"
                v-for="(item, index) in form.listVehicleGroup"
                :key="index"
              >
                <li
                  class="ant-list-item ant-list-item-bordered"
                  v-if="item.vehicle_number > 0"
                >
                  <a-col class="padding-8 textLeft" :span="12">
                    <span style="color: #1890ff">{{
                      item.name_of_vehicle_group_id
                    }}</span>
                  </a-col>
                  <a-col class="padding-8 textLeft" :span="3">
                    <span style="color: #1890ff">{{
                      item.vehicle_number
                    }}</span>
                  </a-col>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </a-col>
      <a-divider
        type="vertical"
        class="divider"
        style="min-height: 500px; margin: 8px"
      />
      <a-col>
        <div class="transport-info">
          <div class="ant-descriptions-title">Trạng thái vận chuyển</div>
        </div>
        <div class="order-steps">
          <a-list
            item-layout="vertical"
            :data-source="transportations"
            size="small"
          >
            <a-empty v-if="transportations.length == 0">
              <template v-slot:description>Không có dữ liệu</template>
            </a-empty>
            <!-- <a-spin v-if="loading"></a-spin> -->
            <template #renderItem="{ item }">
              <a-list-item>
                <a-skeleton :loading="loading" active>
                  <div class="transport-info-wrapper">
                    <a-popover placement="topLeft" arrow-point-at-center>
                      <template #title>
                        <span><strong>Thông tin vận chuyển</strong></span>
                      </template>
                      <template #content>
                        <span v-if="item.name_of_vehicle_id">
                          <CarOutlined />
                          <strong>{{ item.name_of_vehicle_id }} </strong> </span
                        ><br />
                        <span v-if="item.name_of_primary_driver_id">
                          <UserOutlined />
                          {{ item.name_of_primary_driver_id }} </span
                        ><br />
                        <span v-if="item.mobile_of_driver_id">
                          <PhoneOutlined />
                          {{ item.mobile_of_driver_id }} </span
                        ><br />
                        <span v-if="item.name_of_id_no">
                          <IdcardOutlined />
                          {{ item.name_of_id_no }}
                        </span>
                      </template>
                      <div class="info-driver">
                        <span class="title-info-driver">
                          <strong>{{ item.name_of_partner_id }}</strong></span
                        >
                        <br />
                        <span class="title-info-driver">
                          #{{ item.order_code }}</span
                        >
                        <br />
                        <span
                          class="title-info-driver"
                          v-if="item.name_of_vehicle_id"
                        >
                          <strong>{{ item.name_of_vehicle_id }}</strong> ({{
                            item.name_of_vehicle_group_id
                          }})</span
                        >
                        <br />
                        <span
                          class="title-info-driver"
                          v-if="item.name_of_primary_driver_id"
                        >
                          {{ item.name_of_primary_driver_id }} (<span
                            class="phone"
                            >{{ item.mobile_of_driver_id }}</span
                          >)
                        </span>
                        <br />
                        <a-tooltip placement="top">
                          <template #title>
                            <span
                              >Tiền thu hộ
                              {{
                                item.amount_cod
                                  ? formatNumber(item.amount_cod)
                                  : 0
                              }}
                              VND</span
                            >
                          </template>
                          <span
                            class="title-info-driver"
                            v-if="item.amount_cod > 0"
                          >
                            <strong style="color: #c80000"
                              >{{
                                item.amount_cod
                                  ? formatNumber(item.amount_cod)
                                  : 0
                              }}
                              VND</strong
                            ></span
                          >
                        </a-tooltip>
                      </div>
                    </a-popover>
                    <a-timeline>
                      <a-timeline-item
                        :color="renderColor(history)"
                        v-for="(history, index) in item.histories"
                        :key="index"
                        ><span>{{
                          moment(String(history.ins_date)).format(
                            "DD-MM-YYYY HH:mm"
                          )
                        }}</span>
                        {{ renderStep(history) }}
                        <a-list
                          :grid="{ gutter: 16, column: 6 }"
                          :data-source="history.list_files"
                          v-if="history.list_files.length > 0"
                        >
                          <template #renderItem="{ item }">
                            <a-list-item>
                              <a-image :src="item.url" />
                              <a-list-item-meta :description="item.reason" />
                            </a-list-item>
                          </template>
                        </a-list>
                      </a-timeline-item>
                    </a-timeline>
                  </div>
                  <span style="margin: 0 4px" v-if="item.reason != null"
                    >Lý do hủy {{ item.reason }}</span
                  >
                </a-skeleton>
              </a-list-item>
            </template>
          </a-list>
        </div>
      </a-col>
    </a-row>
    <a-row v-if="form.note">
      <a-col :span="24">
        <div class="vehicle-info">
          <div class="ant-descriptions-title">Lưu ý</div>
          <div class="items-info-wrapper">
            {{ form.note }}
          </div>
        </div>
      </a-col></a-row
    >
    <a-row v-if="form.list_files.length > 0">
      <a-col :span="24">
        <div class="vehicle-info">
          <div class="ant-descriptions-title">Thông tin đính kèm</div>
          <div class="items-info-wrapper">
            <a-list
              :grid="{ gutter: 16, column: 8 }"
              :data-source="form.list_files"
            >
              <template #renderItem="{ item }">
                <a-list-item>
                  <a-image class="img-responsive" :src="item.url" />
                </a-list-item>
              </template>
            </a-list>
          </div>
        </div>
      </a-col>
    </a-row>
    <a-modal
      v-model:visible="mapVisible"
      title="Lịch trình vận chuyển"
      centered
      width="60%"
      :bodyStyle="{
        height: 'auto',
        overflow: 'hidden',
        padding: 0,
      }"
    >
      <Map :marker="marker" :map-visible="mapVisible" />
      <template #footer>
        <a-button key="back" @click="hideModal"> Thoát </a-button>
      </template>
    </a-modal>
  </div>
</template>
<script>
import axios from "axios";
import constant from "@/constant";
import utility from "@/utility";
import OrderCustomerService from "@/services/OrderCustomerService";
import FileService from "@/services/FileService";
import Map from "./Map.vue";
import moment from "moment/moment";
import { Modal } from "ant-design-vue";
import {
  QuestionCircleOutlined,
  CarTwoTone,
  BarcodeOutlined,
  CalendarTwoTone,
  EnvironmentTwoTone,
  PhoneTwoTone,
  UserOutlined,
  EnvironmentOutlined,
} from "@ant-design/icons-vue";

export default {
  mixins: [utility],
  props: {
    show: false,
    form: {},
  },
  emits: ["showRate"],
  components: {
    QuestionCircleOutlined,
    CarTwoTone,
    BarcodeOutlined,
    CalendarTwoTone,
    EnvironmentTwoTone,
    PhoneTwoTone,
    UserOutlined,
    EnvironmentOutlined,
    Map,
  },
  data() {
    return {
      moment,
      loading: true,
      current: null,
      status: "",
      transportations: [],
      constant,
      orderCustomerStatus: constant.orderCustomerStatus,
      orderCustomerStatusConstant: constant.orderCustomerStatusConstant,
      orderStatus: constant.orderStatus,
      title: "",
      data: {
        status: null,
        note: null,
      },
      visibleRate: false,
      file_lists: [],
      previewVisible: false,
      previewImage: "",
      loadingImg: true,
      confirmLoading: false,
      key: "",
      visibleRateReview: false,
      urlTracking: "",
      iscopy: false,
      mapVisible: false,
      marker: [],
    };
  },
  mounted() {
    if (this.show) {
      this.transportations = [];
      this.loading = true;
      OrderCustomerService.getOrdersById(this.form.id)
        .then((response) => {
          this.transportations = response.data.data;
          setTimeout(() => {
            this.loading = false;
          }, 1000);
        })
        .catch((error) => {
          this.transportations = [];
          this.$message.error(error.message);
        });
    }
  },
  watch: {},
  methods: {
    renderOrderCustomerStatus(history) {
      const status = this.orderCustomerStatus.find(
        (p) => p.value == history.status
      );
      return status ? status.text : "";
    },
    renderStep(history) {
      const status = this.orderStatus.find(
        (p) => p.value == history.order_status
      );
      return status ? status.text : "";
    },
    renderColor(history) {
      const color = this.orderStatus.find(
        (p) => p.value == history.order_status
      );
      return color ? color.color : "";
    },
    clickReorder() {
      this.$emit("reorder", this.form);
    },
    showModal() {
      this.marker = [];
      OrderCustomerService.getMap(this.form.id)
        .then((response) => {
          this.marker = response.data.data;
        })
        .catch((error) => {
          this.$message.error(error.message);
        });
        this.mapVisible = true;
    },
    hideModal() {
      this.mapVisible = false;
    },
  },
};
</script>
<style scoped lang="scss">
$primary: #c80000;
$green: #7cb305;
$blue: #1890ff;
$light_yellow: #fffcf5;
.transport-info-wrapper {
  margin-top: 0;
  display: flex;
}

.transport-info {
  margin: 16px 0;
}
span.order-content {
  color: black;
}
.textRight {
  text-align: right;
}
.time {
  color: $primary;
}
.info-driver {
  width: 180px;
  min-width: 180px;
}
.button {
  background: $primary;
  border-color: $primary;
}
.review-customer {
  display: block;
  padding: 8px 8px 0 8px;
  background: $light_yellow;
}
.divider {
  border-color: $green;
  margin: 12px 0;
}
.rate-order,
.copy-order {
  margin: 10px 0;
}
.title-info-driver {
  font-size: 12px;
  margin-left: 4px;
}
.title-order {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 14px 10px;
  border: 1px solid #e9e7e7;
  border-radius: 4px;
  position: sticky;
  top: 0;
  z-index: 1;
  background: #fafafa;
  .copy {
    color: #7cb305;
  }
}
.status-order-customer {
  padding: 24px 0 0;
  display: flex;
  justify-content: center;
}
.descriptions-title {
  font-size: 18px;
}
.name-of-destination,
.name-of-arrival {
  margin: 0 0 7px;
  color: rgba(0, 0, 0, 0.8);
}
.mobile-of-destination,
.address {
  color: rgba(0, 0, 0, 0.54);
  font-size: 14px;
}
.order-info {
  padding: 16px;
  padding-bottom: 0;
}
.phone {
  color: $blue;
}
.vehicle-info {
  padding: 16px;
  padding-bottom: 0px;
}
.vehicle-info .ant-descriptions-title {
  padding-bottom: 8px;
}
.content-order,
.title-status {
  font-size: 14px;
  line-height: 16px;
}
.title-status {
  color: $primary;
  text-transform: uppercase;
}
.descriptions-title {
  padding-bottom: 8px;
}
.order-steps :deep() {
  .ant-descriptions-title {
    margin: 8px 0;
  }
  .ant-steps-item-content {
    width: 320px !important;
    min-height: 32px;
  }
}
.upload-list-inline :deep(.ant-upload-list-item) {
  float: left;
  width: 180px;
  margin-right: 8px;
}
.upload-list-inline :deep(.ant-upload-animate-enter) {
  animation-name: uploadAnimateInlineIn;
}
.upload-list-inline :deep(.ant-upload-animate-leave) {
  animation-name: uploadAnimateInlineOut;
}
.items-info-wrapper :deep() .ant-list-item {
  padding: 8px;
}
.footer-wrap {
  padding: 0px 16px 16px;
  :deep() .ant-col {
    padding: 8px;
    border: 1px solid #e6e3e3 !important;
    border-top: none !important;
  }
}
.description-item {
  color: rgba(0, 0, 0, 0.54);
  font-size: 14px;
}
.seperate {
  color: rgba(0, 0, 0, 0.54);
  margin: 0 4px;
  line-height: 16px;
}
li.ant-list-item.ant-list-item-bordered {
  padding: 8px 10px;
  border-top: 1px solid #bdbdbd;
}
.border-right {
  border-right: 1px solid #bdbdbd;
}
.ant-list-header.ant-list-header-sticky {
  padding: 10px;
  background: #f0efef;
}

p.header-list {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
}
.amount {
  color: $primary;
  font-weight: bold;
  font-size: 16px;
}
.step-icon {
  font-size: 24px;
  color: $green;
}
.history-wrapper :deep() {
  .history-step {
    border-radius: 36px;
    border: 3px solid $green;
    padding: 12px;
    background: white;
    top: -24px;
    left: -12px;
    position: absolute;
  }
  .ant-steps-item {
    min-width: 150px;
  }
  .ant-steps-item-content {
    margin-left: 16px;
    margin-top: 32px;
  }
  .ant-steps-item-finish
    > .ant-steps-item-container
    > .ant-steps-item-tail::after {
    background-color: $green;
  }
}

.rate-icon {
  display: flex;
  justify-content: center;
  margin: 8px auto;
}
.rate-note {
  background: #fafafa;
  padding: 8px 24px;
}
.rate-img {
  margin-top: 8px;
}
</style>
<style lang="scss">
.rate-dialog {
  .ant-modal-header {
    border-bottom: 0;
    .ant-modal-title {
      font-weight: bold !important;
    }
  }
}
.ant-image-img.img-responsive {
  width: 110px;
  height: 110px;
  object-fit: cover;
}
</style>
